//ZimbraInstance
import AbstractZimbraInstance       from './AbstractZimbraInstance';

import ObjectList from './ObjectList';

export default class ZimbraInstance extends AbstractZimbraInstance 
{

    update_auth_token : boolean = false;
    //FK
    

    constructor(dict = null)
    {
        super(dict);
    }
}
